import { useNavigate } from "react-router-dom"; // Import navigation hook
import PokalConnectApp from "../component/dashboard_home/PokalConnectApp"
import PokalMedscanApp from "../component/dashboard_home/PokalMedscanApp"
import PokalPlatform from "../component/dashboard_home/PokalPlatform"
import MobileAlternative from "../component/MobileAlternative"
import PsychoEducationBox from "../component/PsychoEducationBox"
import { NAVIGATION_VIEW, NavigationPaths } from "../navigation/NavigationController";


function HomeDashboardView() {
    const navigate = useNavigate(); // Hook for navigation

    return (
        <MobileAlternative>
            <div className="m-4 flex flex-col space-y-4">
                <div className="flex items-end">
                    <div className="text-2xl font-bold">
                        {"Willkommen bei DOORConnect!"}
                    </div>
                </div>

                {/* Main Row */}
                <div className="flex flex-col space-y-20 sm:flex-row sm:space-x-4 sm:space-y-0">
                    <div className="flex-1 flex flex-col">
                        <PokalPlatform />
                    </div>
                    <div className="flex-1 flex flex-col">
                        <PokalConnectApp />

                        {/* Clickable Card Below PokalConnectApp */}
                        <div
                            className="mt-4 bg-white p-4 rounded-lg shadow-md cursor-pointer hover:bg-gray-100 transition"
                            onClick={() => navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_HELP_VIEW].path)}
                        >
                            <h2 className="text-lg font-semibold">Zusätzliche Info zur DOOR Studie Connect App</h2>
                            <p>Hier finden Sie als Patient:in zusätzliche Informationen zur DOOR Studie Connect App sowie den allgemeinen Hilfe Bereich mit FAQs.</p>
                        </div>
                    </div>
                    <div className="flex-1 flex flex-col">
                        <PokalMedscanApp />

                        {/* Clickable Card Below PokalMedscanApp */}
                        <div
                            className="mt-4 bg-white p-4 rounded-lg shadow-md cursor-pointer hover:bg-gray-100 transition"
                            onClick={() => {
                                const targetPath = NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW].path;
                                navigate(NavigationPaths[NAVIGATION_VIEW.SIGN_IN].path, { state: { from: targetPath } });
                            }}
                        >
                            <h2 className="text-lg font-semibold">Zusätzliche Info zur DOOR Studie MedScan App</h2>
                            <p>Hier finden Sie als Ärzt:in zusätzliche Informationen zur DOOR Studie MedScan App sowie den allgemeinen Hilfe Bereich mit FAQs.</p>
                        </div>
                    </div>
                </div>

                {/* Uncomment if you want to use PsychoEducationBox */}
                {/* <PsychoEducationBox /> */}
            </div>
        </MobileAlternative>
    )
}

export default HomeDashboardView
